import { cloudFunction } from 'services/parse';

export const fetchAllSalesChannel = async () => {
  let response = await cloudFunction('fetchAllSalesChannel', {});
  response = response.map(row => {
    return {
      id: row.objectId,
      nameOrEmail: row.full_name + (row.full_name && ' - ') + row.email,
    };
  });
  return response;
};

export const fetchPaginatedAccounts = (data: Record<string, any>) => {
  return cloudFunction('fetchPaginatedAccounts', data);
};

export const fetchUsersForAccount = (data: Record<string, any>) => {
  return cloudFunction('fetchUsersForAccount', data);
};

export const addUserAddress = (data: Record<string, any>) => {
  return cloudFunction('addAddress', data);
};

export const updateUserAddress = (data: Record<string, any>) => {
  return cloudFunction('updateAddress', data);
};

export const fetchUserAddresses = (userId: string) => {
  return cloudFunction('fetchSavedAddressesForUser', { userId });
};

export const addAddress = (data: Record<string, any>) => {
  return cloudFunction('addAddressForUser', data);
};

export const updateAddress = (data: Record<string, any>) => {
  return cloudFunction('updateAddressForUser', data);
};

export const deleteAddress = (id: string) => {
  return cloudFunction('deleteAddressForUser', { id });
};

export const toggleDefaultFlagForAddress = (id: string) => {
  return cloudFunction('toggleDefaultFlagForAddressForUser', { id });
};

export const createExternalOrder = (data: Record<string, any>) => {
  return cloudFunction('createExternalOrder', data);
};

export const quoteOrder = (data: Record<string, any>) => {
  return cloudFunction('quoteOrder', data);
};